"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Avatar = _interopRequireDefault(require("../Avatar"));
var _Name = _interopRequireDefault(require("../Name"));
var _Time = _interopRequireDefault(require("../../Common/Time"));
var _excluded = ["person"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Profile = /*#__PURE__*/function (_React$PureComponent) {
  function Profile() {
    (0, _classCallCheck2["default"])(this, Profile);
    return _callSuper(this, Profile, arguments);
  }
  (0, _inherits2["default"])(Profile, _React$PureComponent);
  return (0, _createClass2["default"])(Profile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        person = _this$props.person,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var avatarUrl = person.avatarUrl,
        name = person.name,
        number = person.number;
      return /*#__PURE__*/_react["default"].createElement(StyledProfile, props, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
        name: name,
        url: avatarUrl
      }), /*#__PURE__*/_react["default"].createElement(StyledDescription, null, /*#__PURE__*/_react["default"].createElement(StyledContact, null, /*#__PURE__*/_react["default"].createElement(StyledName, {
        name: name
      }), /*#__PURE__*/_react["default"].createElement(StyledNumber, null, number)), /*#__PURE__*/_react["default"].createElement(StyledTime, null)));
    }
  }]);
}(_react["default"].PureComponent);
Profile.propTypes = {
  className: _propTypes["default"].string,
  person: _propTypes["default"].shape({
    avatarUrl: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired,
    number: _propTypes["default"].number
  }).isRequired
};
Profile.defaultProps = {
  className: ''
};
var StyledProfile = _styledComponents["default"].div.withConfig({
  displayName: "Profile__StyledProfile",
  componentId: "sc-o02240-0"
})(["color:#4d4d4d;display:flex;"]);
var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "Profile__StyledAvatar",
  componentId: "sc-o02240-1"
})(["height:26px;width:26px;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "Profile__StyledDescription",
  componentId: "sc-o02240-2"
})(["display:flex;flex-direction:column;margin-left:7px;"]);
var StyledContact = _styledComponents["default"].div.withConfig({
  displayName: "Profile__StyledContact",
  componentId: "sc-o02240-3"
})(["display:flex;line-height:26px;"]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "Profile__StyledName",
  componentId: "sc-o02240-4"
})(["font-size:12px;font-weight:normal;"]);
var StyledNumber = _styledComponents["default"].div.withConfig({
  displayName: "Profile__StyledNumber",
  componentId: "sc-o02240-5"
})(["font-size:12px;font-weight:normal;:before{content:'\u22C5';margin:0 5px;}"]);
var StyledTime = (0, _styledComponents["default"])(_Time["default"]).withConfig({
  displayName: "Profile__StyledTime",
  componentId: "sc-o02240-6"
})(["margin-top:-4px;"]);
var _default = exports["default"] = Profile;